
import ChatBot from "@/components/ChatBot";
import Navbar from "@/components/Navbar";
import Footer from "@/components/sections/Footer";
import { SEO } from "@/components/SEO";

const ChatBotPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="SpudBot Assistant" 
        description="Get instant answers to your seed potato questions from our intelligent assistant."
      />
      <Navbar />
      <div className="flex-grow bg-gradient-to-b from-muted to-white pt-28 pb-20">
        <div className="container mx-auto px-4">
          <ChatBot />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ChatBotPage;
